import React from "react";
import { useLocation } from "react-router";
import Error404Page from "../Error404/Error404Page";
import MessageForm from "../../../../components/Messaging/MessageForm/MessageForm";
import { getProductData } from "../../../../services/productService";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "../../../../services/reactQuery/reactQueryService";
import LegalbirdAuthenticatedLoaderPage from "../../Loading/LegalbirdAuthenticatedLoaderPage";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

export default function MessageFormPage() {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const productName = urlSearchParams.get("product") as AbstractCase["name"];
  const productId = urlSearchParams.get("productId");
  const parsedProductId = parseInt(productId || "0");
  const productApiUri = getProductData(productName, "apiUri");

  const { data: product, isLoading } = useQuery({
    queryKey: queryKeys.item(productApiUri, parsedProductId),
    queryFn: () => fetchResource(productApiUri, parsedProductId),
  });

  if (isLoading) {
    return <LegalbirdAuthenticatedLoaderPage />;
  }

  if (!product) {
    return <Error404Page />;
  }

  return (
    <LayoutAuthenticated>
      <MessageForm product={product} />
    </LayoutAuthenticated>
  );
}
